// frontend/src/pages/superadmin/CMSDashboard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaImage, FaUsers, FaGlobe, FaInfoCircle, FaShoePrints } from 'react-icons/fa';

const CMSDashboard = () => {
    const menuItems = [
        { title: 'Hero Sliders', icon: <FaImage />, path: '/website-cms/hero-sliders', description: 'Manage homepage sliders' },
        { title: 'Portals/Cards', icon: <FaGlobe />, path: '/website-cms/portals', description: 'Manage portal cards' },
        { title: 'About Section', icon: <FaInfoCircle />, path: '/website-cms/about', description: 'Edit about content' },
        { title: 'Team Members', icon: <FaUsers />, path: '/website-cms/team', description: 'Manage team profiles' },
        { title: 'Footer', icon: <FaShoePrints />, path: '/website-cms/footer', description: 'Update footer info' },
    ];

    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-6">Content Management Dashboard</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {menuItems.map((item, index) => (
                    <Link to={item.path} key={index} className="block p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
                        <div className="flex items-center gap-4">
                            <div className="text-3xl text-orange-500">{item.icon}</div>
                            <div>
                                <h3 className="text-xl font-semibold">{item.title}</h3>
                                <p className="text-gray-500">{item.description}</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default CMSDashboard;